import { useEffect, useState } from "react";
import useAPI from "../../../services/hooks/useAPI";
import searchAPI from "../../API/searchAPI";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import SearchBar from "../../app/SearchBar/SearchBar";
import { Button, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ViewDownloadsDialog } from "../../dialogs/View-Downloads-Dialog";
import { useAuth } from "../../../hooks/useAuth";
import './style.scss';
import APIService from "../../../services/api.service";
import axios from "axios";
import { CacheService } from "../../../common/services/cache.service";
import environment from "../../../environment/environment";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState } from "../../../atoms/user";
import { tokenState } from "../../../atoms/token";

const MyUploads = () => {
  const { user } = useAuth();
  const [userInfo, setuserInfo] = useRecoilState(userState);

  const [showDialog, setShowDialog] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [reload, setReload] = useState(false);
  const [uploads, setUploads] = useState([]);
  const [token] = useRecoilState(tokenState);

  useEffect(() => {
    console.log('my uploads', userInfo);
    const url = `${environment.eticApiUrl}GetUserUploads?userId=` + userInfo?.userId;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any) => {

      setUploads(res.data.sort((a, b) => (a.dateUploaded > b.dateUploaded) ? -1 : 1));
    });
  }, [userInfo]);

  const viewImage = (row) => {
    let imageUrl = `${environment.eticApiUrl}DownloadUserUpload?id=${row.id}&filename=${row.fileName}&SharedNPSAuthToken=41e1ad0e-0401-4d10-a364-10523f938522`;
    window.open(imageUrl);
  }

  const columns: GridColDef[] = [
    { field: 'parkName', headerName: 'Park Name', width: 400 },
    { field: 'title', headerName: 'Title', width: 400 },
    { field: 'fileName', headerName: 'File Name', width: 200 },
    { field: 'status', headerName: 'Status', width: 100 },
    { field: 'pmisNumber', headerName: 'PMIS', width: 100 },
    { field: 'attachment', headerName: 'Attachment', width: 150, headerClassName: 'bold', renderCell: (cellValues) => {
      return (
        <>
          <Link to={""} aria-label="Home">
              <Button onClick={() => viewImage(cellValues.row)}>
                  <span >{cellValues.row.fileName}</span>
              </Button>
          </Link>
        </>    
      );
    } },
   // { field: 'attachment', headerName: 'Attachment', width: 200 },
    { field: 'link', headerName: 'ETIC Link', width: 100 },
   

  ];
  
  return (
    <>
    {/* <h1>User Uploads: {user?.profile?.name}</h1> */}
    <h1 className="center">My Uploads</h1>
    <h2 className="center">{user?.profile?.name}</h2>

      <div className="search-results">
        <div className="center" style={{ height: 500, width: '100%' }}>
          <DataGrid
             sx={{ '.MuiDataGrid-columnHeaderTitle': {fontWeight: 'bolder'},
             '.MuiDataGrid-columnHeaderTitleContainer': {borderBottom: 1 },
             '.MuiDataGrid-iconButtonContainer': {visibility: 'visible' },
             '.MuiDataGrid-sortIcon': {opacity: 'inherit !important' }
            }}
            rows={uploads.map((row, index) => (
              {
                //park: row.userId,
                id: row.id,
                title: row.title,
                fileName: row.fileName[0] ,
                status: row.status,
                pmisNumber: row.pmisNumber,
                parkName: row.parkName,
              }
            )) || []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            pageSizeOptions={[5, 10, 25, 50]}
            
            loading={!uploads.length}
          />
        </div>
      </div>
    </>
  );
}

export default MyUploads;